import Api from './Api';
import {
  VOUCHER_ADD_URL,
  VOUCHER_CUSTOMERS_LIST_URL,
  VOUCHER_DELETE_URL,
  VOUCHER_LIST_URL,
  VOUCHER_PRODUCT_LIST_URL,
  VOUCHER_UPDATE_CUSTOMERS_URL,
  VOUCHER_UPDATE_PRODUCTS_URL,
  VOUCHER_UPDATE_URL,
} from './constants';

export default class Voucher extends Api {
  static async list(params = null) {
    const url = params
      ? `${VOUCHER_LIST_URL}?${Api.$instance.dataToUrl(params)}`
      : VOUCHER_LIST_URL;

    return Api.$instance.get(url);
  }

  static async productList() {
    return Api.$instance.get(VOUCHER_PRODUCT_LIST_URL);
  }

  static async customersList(params = null) {
    const url = params
      ? `${VOUCHER_CUSTOMERS_LIST_URL}?${Api.$instance.dataToUrl(params)}`
      : VOUCHER_CUSTOMERS_LIST_URL;

    return Api.$instance.get(url);
  }

  static async addVoucher(data) {
    return Api.$instance.get(`${VOUCHER_ADD_URL}?${Api.$instance.dataToUrl(data)}`);
  }

  static async updateVoucher(data) {
    return Api.$instance.get(`${VOUCHER_UPDATE_URL}?${Api.$instance.dataToUrl(data)}`);
  }

  static async deleteVoucher(data) {
    return Api.$instance.get(`${VOUCHER_DELETE_URL}?${Api.$instance.dataToUrl(data)}`);
  }

  static async updateVoucherProducts(data) {
    return Api.$instance.get(`${VOUCHER_UPDATE_PRODUCTS_URL}?${Api.$instance.dataToUrl(data)}`);
  }

  static async updateVoucherCustomers(data) {
    return Api.$instance.get(`${VOUCHER_UPDATE_CUSTOMERS_URL}?${Api.$instance.dataToUrl(data)}`);
  }
}